const userLabel = require("../label/user");

const note_user_subscriber = {
  key: "note_user_subscriber",
  count_alias: "count_user_subscribers_new",
  label_activity: "subscribers and/or subscriber requests",
  label_data: "new subscriber",
  label_detail: "A user subscribes to me or sends me a subscription request.",
  label_title: ({ subscription_code }) =>
    "New Subscriber" + (!subscription_code ? " (Request)" : ""),
  label_zero_state:
    "When a user subscribes to you or sends you a subscription request, we'll notify you here.",
  makeNote: ({ subscription_code, ...user }) =>
    userLabel(user) +
    (subscription_code
      ? " subscribed to you."
      : " requested to subscribe to you."),
  makeLink: ({ username }) => "/user/" + username,
  table: "subscription",
  leftJoins: [null, "subscriber_user"],
  keys: [
    "subscription.id AS id",
    "subscription.created_at AS noted_at",
    "subscription.code AS subscription_code",
    "subscriber_user.username AS username",
    "subscriber_user.display_name AS display_name",
  ],
  wheres: ["subscription.subscription_id = ?"],
  where_since: {
    index: 1,
    sql: "subscription.created_at >= ?",
    key: "note_last",
  },
  escapeValues: (user) => [user.id],
};

module.exports = note_user_subscriber;
